import { useState } from "react";
import { Container, Row } from "reactstrap";
import { Email, LetterBoxTitle } from "../../../constants";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import Sidebar from "./sidebar";
import EmailList from "./emailList";

const LetterBoxContainer = () => {
  const [navId, setNavId] = useState("1");

  return (
    <>
      <Breadcrumbs mainTitle={LetterBoxTitle} parent={Email} />
      <Container fluid>
        <div className="message-wrap email-main-wrapper">
          <Row>
            <Sidebar navId={navId} setNavId={setNavId} />
            <EmailList navId={navId} />
          </Row>
        </div>
      </Container>
    </>
  );
};

export default LetterBoxContainer;
